// extracted by mini-css-extract-plugin
export var main = "layout-module--main--OqWC9";